import { BottomSheetModal, useModal } from "@becon-team/becon-fe-lib/my-modal";
import { useCallback } from "react";
import { useTranslation } from "react-i18next";

import { modalIds } from "libs/my-modal";
import { getScalpMeasureItemAppendix, getScalpMeasureItemData } from "@becon-team/becon-fe-lib/utils";
import { BeconScalpTypes, Undefinable } from "@becon-team/becon-fe-lib/my-types";

type ModalParams = {
  type: BeconScalpTypes.ScalpMeasureItem;
};

export const ScalpMeasureItemAppendixModal = () => {
  const modalId = modalIds["scalp-measure-item-appendix"];
  const { t } = useTranslation();

  const { modal, closeModal } = useModal(modalId);
  const { isOpened, params } = modal;
  const { type } = (params as Undefinable<ModalParams>) || {};

  const scalpMeasureItemData = type && getScalpMeasureItemData(t, type, undefined);
  const scalpMeasureItemAppendix = type && getScalpMeasureItemAppendix(t, type);

  const displayTitle = scalpMeasureItemData?.text || t("참고 자료");

  return (
    <BottomSheetModal
      closeModal={closeModal}
      titleSection={displayTitle}
      isOpened={isOpened}
      isCloseModalOutsideClick={true}
    >
      <div className="px-inner-padding pb-sp-32">
        <div>{scalpMeasureItemAppendix?.info}</div>

        {scalpMeasureItemAppendix?.sensorInfo && (
          <div className="mt-sp-16 rounded-md bg-base-50 px-inner-padding py-sp-16 text-sm">
            {scalpMeasureItemAppendix.sensorInfo}
          </div>
        )}

        {scalpMeasureItemAppendix?.images && (scalpMeasureItemAppendix.images.length || 0) > 0 && (
          <div className="mt-sp-16 grid grid-cols-3 gap-sp-12">
            {scalpMeasureItemAppendix.images.map((image, idx) => (
              <div key={idx}>
                <img src={image.imageUrl} className="b aspect-1 rounded-md bg-base-50" />
                <div className="mt-sp-6 text-center text-sm text-base-500">{image.text}</div>
              </div>
            ))}
          </div>
        )}
      </div>
    </BottomSheetModal>
  );
};

export const useScalpMeasureItemAppendixModal = () => {
  const { modal, openModal, closeModal } = useModal(modalIds["scalp-measure-item-appendix"]);

  const openModalCallback = useCallback(
    (params: ModalParams) => {
      openModal(params);
    },
    [openModal],
  );

  return {
    openModal: openModalCallback,
    closeModal,
    isOpened: modal.isOpened,
  };
};
